import { FEEDBACK_MESSAGES } from '../../config'
import { addErrorMsg } from './addErrorMsg'

export function customValidationMsg() {
  const inputEmail = document.getElementById('email-en')

  if (inputEmail !== null) {
    if (inputEmail.value === '') {
      addErrorMsg({
        field: 'email',
        msg: FEEDBACK_MESSAGES.ERROR.EMAIL_REQUIRED_EN
      })
    }
  }
}
